<template>
    <div style="cursor: pointer;color:#fff;text-align: center;" :style="{background:bg}" @click="change">
        {{ item }}
    </div>
</template>
<script>
export default {
    props: ['value', "selectItems"],
    data() {
        return {
            item: '',
            bg:'red',
            bgs:['#f04747','blue']
            // item: ['人民币', '港币']
        }
    },
    methods: {
        change() {
            var items = this.selectItems;


            if (this.item == items[0]) {
                this.item = items[1];
                this.bg=this.bgs[1];
            } else {
                this.item = items[0];
                this.bg=this.bgs[0];
            }
            this.$emit('abc', this.item);
        },
        tt(){
            this.item = this.value;
            var items = this.selectItems;
            if (this.item == items[0]) {
                this.bg=this.bgs[0];
            } else {
                this.bg=this.bgs[1];
            }
        }
    },
    model: {
        prop: 'value',
        event: 'abc'
    },
    watch: {
        value() {
            this.tt();
        }
    },
    mounted() {
        this.tt();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/toggle.vue